export default __webpack_public_path__ + "static/media/7.8dd82f54.png";